export default __webpack_public_path__ + "static/media/rest2.b68928b9.jpg";